<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path stroke="#000" d="M5.79688 13.2857V12.7857H5.29688H3.4129L12 3.72679L20.5871 12.7857H18.7031H18.2031V13.2857V20.5H14V16V15.5H13.5H10.5H10V16V20.5H5.79688V13.2857Z"/>
</svg>
